import React from "react";
import './CancelPolicy.css';

const CancelPolicy = () => {
  return (
    <div className="cancelpolicy-ap row">
      <div className="cancelpolicy-wrap col-xl-12">

        {/* HERO */}
        <section className="cancelpolicy-hero">
          <h1>Cancellation & Return Policy </h1>
          <p>Simple. Fair. Thoughtfully designed.</p>
          <p>At Garshya, every policy reflects what we stand for — clarity, quality, and trust.</p>
        </section>

        {/* SECTIONS */}
        <section className="cancelpolicy-section">

          <h2>Order Cancellation</h2>
          <h3>Before Shipment</h3>
          <ul>
            <li>Orders can be cancelled before they are shipped</li>
            <li>If already paid, a full refund will be processed to the original payment method</li>
          </ul>

          <h3>After Shipment</h3>
          <ul>
            <li>Once an order is shipped, cancellation may not be possible</li>
            <li>You may request a return (if eligible) after delivery</li>
          </ul>

          <h3>For COD Orders</h3>
          <ul>
            <li>COD orders are confirmed only after 10% advance payment</li>
            <li>This advance is non-refundable if the order is cancelled after confirmation, as it covers processing and logistics costs</li>
          </ul>

          <h2>Return Policy</h2>
          <p>We accept returns only for products that meet our quality and eligibility criteria.</p>

          <h3>Eligible for Return if:</h3>
          <ul>
            <li>Product is damaged, defective, or incorrect</li>
            <li>Product does not match the description</li>
            <li>Return request is raised within 48 hours of delivery</li>
          </ul>

          <h3>Not Eligible for Return:</h3>
          <ul>
            <li>Change of mind after delivery</li>
            <li>Minor variations (color/finish due to screen differences)</li>
            <li>Products marked as non-returnable on the product page</li>
            <li>Items that are used, damaged after delivery, or without original packaging</li>
          </ul>

          <h3>Return Process</h3>
          <ul>
            <li>Initiate a return via Contact Us or support email</li>
            <li>Share order details and issue (with images if required)</li>
            <li>Our team will review and confirm eligibility</li>
            <li>Pickup will be arranged (where serviceable) or you may be guided for self-shipping</li>
          </ul>
          <p>We aim to keep the process smooth and transparent.</p>

          <h2>Refund Policy</h2>
          <ul>
            <li>Refunds are processed after quality check and approval</li>
            <li>Timeline: 5–7 business days after approval</li>
            <li>Refund will be issued to:
              <ul>
                <li>original payment method, or</li>
                <li>bank account (for COD orders)</li>
              </ul>
            </li>
          </ul>

          <h2>Important Notes</h2>
          <ul>
            <li>Garshya reserves the right to approve or reject returns after inspection</li>
            <li>In case of repeated or suspicious return requests, we may limit return access</li>
            <li>Shipping charges (if applicable) may not be refundable unless the issue is from our end</li>
          </ul>

          <h2>Our Approach</h2>
          <p>We are not built for frequent returns. We are built to ensure you get it right the first time.</p>
          <p>Every product is carefully selected so that returns become the exception, not the habit.</p>
          <p>Garshya — Because the right choice shouldn’t need a second one.</p>

        </section>

      </div>
    </div>
  );
};

export default CancelPolicy;